import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../app/store'
import swal from 'sweetalert'
import FormNumbering from './FormNumbering'
import { updateAddressSnackBar } from '../profileSlice'
import { getSettingCustomNumberInvoice, updateSettingCustomNumberInvoice } from '../reducers/profilesReducers'


const InvoiceNumbering : React.FC<any> = ({profile}) => {

    const dispatch = useDispatch()
    const { 
        loading_invoice_number, invoice_number, 
        loading_update_invoice_number, update_invoice_number 
    } = useSelector((state : RootState) => state.profile)

    const [valueForm, setValueForm] = useState<any>({
        counterNumberOfDigits : "4",
        counterMaxValue : 9999,
        counterResetValue : "1",
        startingNumber : "0001",
        counterReset : "yearly",
        result : ""
    });

    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState(false);

    const onClickSave = (e:any) => {
        e.preventDefault()
        let body = {
            "company": profile._id,
            "format": inputValue,
            "counterNumberOfDigits": parseInt(valueForm.counterNumberOfDigits),
            "counterResetValue": parseInt(valueForm.counterResetValue),
            "counterMaxValue": valueForm.counterMaxValue,
            "startingNumber": valueForm.startingNumber,
            "counterReset": valueForm.counterReset,
        }
        if(!error) {
            if(parseInt(valueForm.counterNumberOfDigits) !== valueForm.startingNumber.length) {
                swal('Error', 'Counter starting value must be the same with digits of counter number!', 'error')
                return
            } else if (parseInt(valueForm.counterNumberOfDigits) !== valueForm.counterMaxValue.toString().length) {
                swal('Error', 'Counter max value must be the same with digits of counter number!', 'error')
                return
            } else {
                dispatch(updateSettingCustomNumberInvoice(body))
            }
        }
    }

    function fetchData() {
        if(profile._id) {
            dispatch(getSettingCustomNumberInvoice(profile._id))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(update_invoice_number) {
            setTimeout(() => {
                // fetchData()
                dispatch(updateAddressSnackBar())
            }, 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [update_invoice_number]);


    useEffect(() => {
        if(!isEmpty(invoice_number)) {
            setValueForm({
                counterNumberOfDigits : invoice_number.counterNumberOfDigits,
                counterMaxValue : invoice_number.counterMaxValue,
                counterResetValue : invoice_number.counterResetValue,
                startingNumber : invoice_number.startingNumber,
                counterReset : invoice_number.counterReset,
                result : invoice_number.result
            })
            setInputValue(invoice_number.format)
        }
    }, [invoice_number]);

    // create a function check object is not empty
    const isEmpty = (obj:any) => {
        return Object.keys(obj).length === 0;
    }

    return (
    <div>
        <FormNumbering 
            valueForm={valueForm}
            setValueForm={setValueForm}
            inputValue={inputValue}
            setInputValue={setInputValue}
            onClickSave={onClickSave}
            loading_update={loading_update_invoice_number}
            loading={loading_invoice_number}
            update={update_invoice_number}
            error={error}
            setError={setError}
            name="Invoice"
        />
    </div>
  )
}

export default InvoiceNumbering